const env = process.env.NODE_ENV

const Setting = {
    /**
     * 基础配置
     * */
    // 路由模式，可选值为 history 或 hash
    routerMode: 'hash',
    // 1是H5页面 2是安卓 3是sIOS
    isMoudle: 1,
    apiBaseURL: process.env.VUE_APP_API_BASE_URL,
    ossBaseUrl: process.env.VUE_APP_OSS_BASE_URL,
    // 接口请求返回错误时，弹窗的持续时间，单位：毫秒
    modalDuration: 1000,
    // 接口请求返回错误时，弹窗的类型，可选值为 Toast 或 Notify
    errorModalType: 'Toast',
    // Cookies 默认保存时间，单位：天
    cookiesExpires: 1
}

export default Setting
